<div [class]="center ? 'flex justify-center items-center w-full' : 'w-full'">
    <div class="w-full flex flex-col gap-1 items-start">
        <label class="font-bold text-gray-900 text-sm">{{ label }}</label>
        <p-toggleswitch
            styleClass="[&.p-toggleswitch-checked_.p-toggleswitch-slider]:!bg-primary [&.p-toggleswitch-checked:not(.p-disabled):hover_.p-toggleswitch-slider]:!bg-primary"
            [(ngModel)]="value"
            (onChange)="changeValue($event)"
        ></p-toggleswitch>
    </div>
</div>
